export default "__VITE_ASSET__BTTqOplF__"